import { CalendarXIcon, LockSimpleIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'

/** Why booking can't start yet, in the opt-out banner's shape: an icon circle and one sentence. */
export function ScheduleUnavailableNote({ locked, reason }: { locked: boolean; reason: string }): ReactElement {
  return (
    <div className="flex items-center gap-2">
      <span
        aria-hidden
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-surface-strong text-subtle"
      >
        {locked ? <LockSimpleIcon className="h-4 w-4" /> : <CalendarXIcon className="h-4 w-4" />}
      </span>
      <span className="flex-1 text-body-sm text-default">{reason}</span>
    </div>
  )
}
